/* eslint-disable react-perf/jsx-no-new-object-as-prop,react-perf/jsx-no-new-function-as-prop,react/no-multi-comp */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from '@rebass/grid';

import { Heading4, Text2, Link } from 'app/shared/ui';
import { noop } from 'app/shared/utils/utils';
import { trackAction } from 'app/shared/utils/tracking';
import { NEWSLETTER_SOURCE } from 'app/marketplace/crm/constants';
import { NewsletterSignupForm } from 'app/shared/components/NewsletterSignupForm/NewsletterSignupForm';
import {
  ImageWrapperSt,
  ModalWrapperSt,
  SuccessTextSt,
} from 'app/marketplace/SlideInBanners/CrmBanner/DesktopBanner/DesktopBanner.css';
import { useSlideIn } from 'app/marketplace/SlideInBanners/shared/hooks/desktop/useSlideIn';

import { ModalSt, LegalCopySt, IconCloseSt } from './DesktopBanner.css';

export const trackSubmit = () => ({
  init: () =>
    trackAction('user_survey_submit_initialized', {
      category: 'user_survey',
      description: 'user submits email address in user survey crm',
      label: 'newsletter_signup',
    }),
  success: () =>
    trackAction('user_survey_submit_successful', {
      category: 'user_survey',
      description: 'user successfully submits email address in user survey crm',
      label: 'newsletter_signup',
    }),
  fail: () =>
    trackAction('user_survey_submit_failed', {
      category: 'user_survey',
      description: 'user fails to submit email address in user survey crm',
      label: 'newsletter_signup',
    }),
});

const trackingRender = () =>
  trackAction('user_survey_displayed_on_desktop', {
    category: 'user_survey',
    description: 'user views user survey on desktop',
    label: 'newsletter_signup',
  });

export const DesktopBanner = ({
  onFormSubmit,
  finishSubmit,
  threshold,
  done,
  onClose,
  areCookiesAccepted,
  submitted,
}) => {
  const [hide] = useState(submitted);
  const [mode, changedToVisible] = useSlideIn(threshold);

  useEffect(() => {
    if (changedToVisible) {
      trackingRender();
    }
  }, [changedToVisible]);

  const closeModal = () => {
    trackAction(
      `user_survey_closed_${done ? 'after_submit' : 'without_submit'}`,
      {
        category: 'user_survey',
        description: `user closes user survey ${
          done ? 'after form submission' : 'without submitting form'
        }`,
        label: 'newsletter_signup',
      },
    );
    onClose(areCookiesAccepted);
  };

  const renderSuccess = () => (
    <ModalWrapperSt background="white" isFlex column alignCenter justifyCenter>
      <ImageWrapperSt width={104}>
        <img src="/assets/mailtrain/subscription.svg" alt="" />
      </ImageWrapperSt>
      <SuccessTextSt>
        Danke für dein Interesse. Den Link zur Teilnahme findest du in deinem
        E-Mail-Postfach.
      </SuccessTextSt>
    </ModalWrapperSt>
  );

  const renderForm = () => (
    <div>
      <Flex>
        <Box p={16} width="68%">
          <Heading4 fontSize={24}>Wilkommen auf heycar!</Heading4>
          <Text2 lineHeight="24px" marginBottom={24} as="p">
            Bist du mit unserer Webseite zufrieden? Bewerte deine Erfahrung auf
            heycar und gewinne einen 200€ Shell-Tankgutschein. Gib einfach deine
            E-Mail-Adresse an und erhalte sofort deinen Teilnahmelink:
          </Text2>
          <NewsletterSignupForm
            onFormSubmit={onFormSubmit}
            onSuccess={finishSubmit}
            trackSubmit={trackSubmit}
            alignMessage="left"
            placeholder="E-Mail-Adresse"
            source={NEWSLETTER_SOURCE.userSurvey}
          />
        </Box>
        <Box pt={54} width="32%">
          <img
            src="/assets/user-survey/UX_Survey_Desktop.png"
            alt="user survey entrypoint"
          />
        </Box>
      </Flex>
      <LegalCopySt>
        Unter den Teilnahmeberechtigten verlosen wir einen Shell-Tankgutschein
        im Wert von 200€ im Zeitraum vom 9.9.2020 bis 9.12.2020, 23:59 Uhr
        (MEZ). Die vollständigen Gewinnspielbedingungen findest du hier und
        Infos zum Datenschutz{' '}
        <Link useRouter={false} target="_blank" href="/privacy">
          hier
        </Link>
        .
      </LegalCopySt>
    </div>
  );

  // When component mounts, check if form has been previously submitted
  // if yes, do not render
  if (hide) return null;

  return (
    <ModalSt mode={mode}>
      <IconCloseSt className="if-icon-close" onClick={closeModal} />
      {done ? renderSuccess() : renderForm()}
    </ModalSt>
  );
};

DesktopBanner.propTypes = {
  onFormSubmit: PropTypes.func,
  finishSubmit: PropTypes.func,
  threshold: PropTypes.number.isRequired,
  done: PropTypes.bool,
  areCookiesAccepted: PropTypes.bool,
  onClose: PropTypes.func,
  submitted: PropTypes.bool,
};

DesktopBanner.defaultProps = {
  onFormSubmit: noop,
  finishSubmit: noop,
  areCookiesAccepted: false,
  onClose: noop,
  done: false,
  submitted: false,
};
